export default __webpack_public_path__ + "static/media/bg_gelbs2.d2a83119.png";